import React, { useEffect } from "react";
import { Link } from "react-router-dom";

//

//JSON
import dataHomeImg from "./dataHome.json";

// fade animation related AOS
import Aos from "aos";
import "aos/dist/aos.css";
//
// zoom in related
import { motion } from "framer-motion";
//<motion.  add this to any img you want to scale
//
//
//
//
const HomeCityMono = () => {
  //

  //
  //
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  const cardDataJson = dataHomeImg;
  //
  return (
    <React.Fragment>
      <section id="home">
        <div className="home___wrapper">
          {/*
            
            
            
            
           */}{" "}
          <div className="header__Top1">
            {/* heading */}{" "}
            <div className="header__Top1__title">
              <h1 data-aos-duration="1000" data-aos="fade-up">
                3D ARTIST
                <span className="italic__HeaderHomeTop">&#x26;</span>CREATIVE
                DEVELOPER BASED IN BERLIN.
              </h1>
            </div>
            <div className="header__Top1__titleTab">
              <h2> Below: Lethe City</h2>
              <p> 2008 | 2021</p>
            </div>
          </div>
          {/*
            
            
            
            
           */}
          {/* ------------ */}
          {/*Home Lethe img lg*/}
          {/* ------------ */}
          <div className="home__lethe_img_lg">
            <div className="home__lethe_img_lgWrapper">
              <div className="home__lethe_img_lgContainer">
                {cardDataJson
                  .filter(
                    (itemCardHomeImg) =>
                      itemCardHomeImg.title === "ImgVideoWelcomePage1"
                  )
                  .map((itemCardHomeImg) => (
                    // the key must to have a DIV, the div dont necessarily need styles, it just serves as a wrapper, without it, it will show an error
                    <div key={itemCardHomeImg.id}>
                      {/*  */}
                      <Link to="/LetheCity">
                        <img
                          className="img-box-Misc"
                          src={itemCardHomeImg.img1}
                          alt="img city mono preview"
                        />
                      </Link>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          {/*
            
             
            
            
            
           */}
          <div id="home__description">
            {/* -------1----- */}
            <div className="home_ImgDescription__card1">
              <div className="home__img">
                <div className="containerImgBox">
                  {cardDataJson
                    .filter(
                      (itemCardHomeImg) =>
                        itemCardHomeImg.title === "HomeDescriptOneWelcomeImg"
                    )
                    .map((itemCardHomeImg) => (
                      <div className="img-key" key={itemCardHomeImg.id}>
                        <div className="img-box-Misc_desktop">
                          <Link to="/LetheCity">
                            <img
                              src={itemCardHomeImg.img1}
                              alt="img city mono preview"
                            />
                          </Link>
                        </div>
                      </div>
                    ))}

                  {/* zoomed for mobile ------*/}
                  {cardDataJson
                    .filter(
                      (itemCardHomeImg) =>
                        itemCardHomeImg.title ===
                        "HomeDescriptOneWelcomeImgZoomedMobile"
                    )
                    .map((itemCardHomeImg) => (
                      <div key={itemCardHomeImg.id}>
                        <div className="img-box-mobile">
                          <Link to="/LetheCity">
                            <img
                              src={itemCardHomeImg.img1}
                              alt="img city mono preview"
                            />
                          </Link>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            {/* -------2----- */}
            <div className="home_ImgDescription__card2">
              <div className="home__text">
                <h2>
                  LETHE CITY IS INSPIRED BY
                  <span className="italic__HeaderHomeTop">
                    {" "}
                    THE RIVER{" "}
                  </span>{" "}
                  THAT FLOWED THROUGH HYPNOS
                </h2>
                <p>
                  The water was said to cause forgetfulness and oblivion. The
                  name for the city was chosen because the Senate, whose 7
                  members rule unanimously, keep their power by inducing
                  forgetfulness in their citizens.
                </p>
                <h5>
                  <Link to="/LetheCity" className="arrow1-to-left">
                    <span>&#x2190;</span> Read More
                  </Link>
                </h5>

                {/* ------ */}
                <h5>
                  <Link to="/LetheCity" className="arrow1-to-right">
                    <span>&#x2192;</span> Read More
                  </Link>
                </h5>
              </div>
            </div>
          </div>
          {/*
            
             
            
            
            
        */}
          <div className="header__Top2">
            {/* heading */}{" "}
            <div className="header__Top2__title">
              <h1 data-aos-duration="1000" data-aos="fade-down">
                FEATURED
              </h1>
            </div>
            <div className="header__Top2__titleTab">
              <h2> Below: The Simurgh Mountain</h2>
              <p> 2021</p>
            </div>
          </div>
          {/* ---------- */}
          {/* FEATURED   */}
          {/* ---------- */}
          <div id="featuredPortoflio__Scroll">
            <div className="featuredPortoflio_scroll_LG_imgWrapper">
              <div className="featuredPortoflio_scroll_LG_imgContainer">
                <div className="featuredPortoflio_scroll_LG__description">
                  <h1>Simurgh</h1>
                  <h2>Mountain</h2>
                  <h3>In Progress</h3>
                  <h3>2008 | 2021</h3>
                  <p>
                    A Persian poem, written by the famous Sufi poet Farid ud-Din
                    Attar, depicts a great flock of thousands of birds who
                    believe themselves lost without a leader in the world. These
                    birds are meant to represent all the faults that keeps
                    humans from finding enlightenment.
                  </p>
                  <Link to="/simurgh">
                    <button
                      data-aos-duration="1000"
                      data-aos="fade-down"
                      className="organicCity__button"
                    >
                      See More
                    </button>{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/*
            
             
                 The following is a duplicate of the div on top,
                 just change the text and nothing more
            
            
        */}
          {/* ------------------ */}
          <div id="home__description">
            {/* -------1----- */}
            <div className="home_ImgDescription__card1">
              <div className="home__img">
                <div className="containerImgBox">
                  {cardDataJson &&
                    cardDataJson
                      .filter(
                        (itemCardHomeImg) =>
                          itemCardHomeImg.title === "HomeDescriptTwoWelcomeImg2"
                      )
                      .map((itemCardHomeImg) => (
                        <div key={itemCardHomeImg.id}>
                          <div className="img-box-Misc_desktop">
                            {" "}
                            <Link to="/CityOrganic">
                              <img
                                src={itemCardHomeImg.img1}
                                alt="img city mono preview"
                              />
                            </Link>
                          </div>
                        </div>
                      ))}

                  {/* zoomed for mobile */}
                  {cardDataJson
                    .filter(
                      (itemCardHomeImg) =>
                        itemCardHomeImg.title ===
                        "HomeDescriptTwoWelcomeImgZoomedMobile2"
                    )
                    .map((itemCardHomeImg) => (
                      <div key={itemCardHomeImg.id}>
                        <div className="img-box-mobile">
                          <Link to="/CityOrganic">
                            <img
                              src={itemCardHomeImg.img1}
                              alt="img city mono preview"
                            />
                          </Link>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            {/* -------2----- */}
            <div className="home_ImgDescription__card2">
              <div className="home__text">
                <h2>METAMORPHOSIS_ DREAMS_ AND HOW THEY INSPIRED ME</h2>
                <p>
                  When I first began this project I hadn't yet decided on a
                  concrete storyline for my ideas. I was slowly developing one
                  as the creative process went on, since I had been inspiring
                  myself from a plethora of sources, like science-fiction,
                  artists, and most important of all, nature.
                </p>

                <h5>
                  <Link to="/cityOrganic" className="arrow1-to-left">
                    <span>&#x2190;</span> Read More
                  </Link>
                </h5>

                {/* ------ */}
                <h5>
                  <Link to="/LetheCity" className="arrow1-to-right">
                    <span>&#x2192;</span> Read More
                  </Link>
                </h5>
              </div>
            </div>
          </div>
          {/* 
          
          
          
          
          */}
          {/* <div className="header__Top2">
          
            <div className="header__Top2__title">
              <h1 data-aos-duration="1000" data-aos="fade-down">
                DRAWINGS
              </h1>
            </div>
            <div className="header__Top2__titleTab">
              <h2> Below: The Rep. of Utopia</h2>
              <p> 2010</p>
            </div>
          </div> */}
          {/* ---------- */}
          {/* DRAWINGS   */}
          {/* ---------- */}
          {/* <div id="featuredDrawings__Scroll">
            <div className="featuredDrawings_scroll_LG_imgWrapper">
              <div className="featuredDrawings_scroll_LG_imgContainer">
                <div className="featuredDrawings_scroll_LG__description">
                  <Link to="/drawings">
                    <button
                      data-aos-duration="1000"
                      data-aos="fade-down"
                      className="organicCity__button"
                    >
                      See More
                    </button>{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div> */}
          {/* 
          
          
          
          
          */}
          <div className="header__Top2">
            {/* heading */}{" "}
            <div className="header__Top2__title">
              <h1 data-aos-duration="1000" data-aos="fade-down">
                INDUSTRIAL
              </h1>
            </div>
            <div className="header__Top2__titleTab">
              <h2> Below: Mid Century Studies</h2>
              <p> 2008 | 2021</p>
            </div>
          </div>
          {/* 
          
                       INDUSTRIAL
          
          
          */}
          <div className="descript__row">
            <div className="descript__row__wrapper">
              <div className="descript__row_heading">
                <h1>PREFACE</h1>
                <h2>Below:</h2>

                <p> Software Used: </p>
                <p>Blender | 3ds Max | Photoshop </p>
              </div>
              <div className="descript__row_article">
                <h1>
                  <br />
                  When I made the decision to branch out into a new field, after
                  a decade of working in the art world,
                  <span>
                    it was with the strong purpose of creating environments
                    based on my aesthetics.{" "}
                  </span>{" "}
                  I knew from the beginning that it would be a long way until I
                  reached that goal. This resulted in me learning as many skills
                  as I thought would be necessary to build a substantial
                  foundation in the field.
                </h1>
              </div>
            </div>
          </div>
          {/*           MODAL            */}
          <div className="MiscGalleryWrapper">
            <div className="MiscGallery__container__grid">
              <div className="miscImgOne">
                {cardDataJson
                  .filter(
                    (itemCardHomeImg) =>
                      itemCardHomeImg.title === "GeorgeNakashimaImgChair"
                  )
                  .map((itemCardHomeImg) => (
                    <div key={itemCardHomeImg.id}>
                      <Link to="/Furniture">
                        <motion.img
                          data-aos="fade-up"
                          data-aos-duration="1000"
                          whileHover={{ scale: 1.2 }}
                          onHoverStart={(e) => {}}
                          onHoverEnd={(e) => {}}
                          className="img-box-Misc"
                          src={itemCardHomeImg.img1}
                          alt="img city mono preview"
                        />
                      </Link>
                    </div>
                  ))}
              </div>
              {/* -------------------- */}
              <div className="miscImgOne">
                {cardDataJson
                  .filter(
                    (itemCardHomeImg) =>
                      itemCardHomeImg.title === "Mies_Van_der_RoheChair"
                  )
                  .map((itemCardHomeImg) => (
                    <div key={itemCardHomeImg.id}>
                      <Link to="/Furniture">
                        <motion.img
                          data-aos="fade-up-right"
                          data-aos-duration="1000"
                          whileHover={{ scale: 1.2 }}
                          onHoverStart={(e) => {}}
                          onHoverEnd={(e) => {}}
                          className="img-box-Misc"
                          src={itemCardHomeImg.img1}
                          alt="img city mono preview"
                        />
                      </Link>
                    </div>
                  ))}
              </div>
              {/* ------------ */}
              <div className="miscImgOne">
                {cardDataJson
                  .filter(
                    (itemCardHomeImg) =>
                      itemCardHomeImg.title === "MarcelBreuerImgChair"
                  )
                  .map((itemCardHomeImg) => (
                    <div key={itemCardHomeImg.id}>
                      <Link to="/Furniture">
                        <motion.img
                          data-aos="fade-up"
                          data-aos-duration="1000"
                          whileHover={{ scale: 1.2 }}
                          onHoverStart={(e) => {}}
                          onHoverEnd={(e) => {}}
                          className="img-box-Misc"
                          src={itemCardHomeImg.img1}
                          alt="img city mono preview"
                        />
                      </Link>
                    </div>
                  ))}
              </div>

              {/* ------------------ */}
              <div className="miscImgOne">
                {cardDataJson
                  .filter(
                    (itemCardHomeImg) =>
                      itemCardHomeImg.title === "OlaviKettunen_Img_Chair"
                  )
                  .map((itemCardHomeImg) => (
                    <div key={itemCardHomeImg.id}>
                      <Link to="/Furniture">
                        <motion.img
                          data-aos="fade-up-left"
                          data-aos-duration="1000"
                          whileHover={{ scale: 1.2 }}
                          onHoverStart={(e) => {}}
                          onHoverEnd={(e) => {}}
                          className="img-box-Misc"
                          src={itemCardHomeImg.img1}
                          alt="img city mono preview"
                        />
                      </Link>
                    </div>
                  ))}
              </div>
            </div>
            {/*  */}
          </div>
          {/* ---------- LG ------------- */}
          <div className="LG_imgSofa">
            <div className="wrapper__imgSofa">
              <div className="container__imgSofa">
                {cardDataJson
                  .filter(
                    (itemCardHomeImg) =>
                      itemCardHomeImg.title === "midCentury_black_vinyl_Sofa"
                  )
                  .map((itemCardHomeImg) => (
                    <div key={itemCardHomeImg.id}>
                      <Link to="/Furniture">
                        <motion.img
                          data-aos="fade-right"
                          data-aos-duration="1000"
                          whileHover={{ scale: 1.2 }}
                          onHoverStart={(e) => {}}
                          onHoverEnd={(e) => {}}
                          className="img-box-Misc"
                          src={itemCardHomeImg.img1}
                          alt="img city mono preview"
                        />
                      </Link>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          {/*
            
             
            
            
        */}
        </div>
      </section>
    </React.Fragment>
  );
};

export default HomeCityMono;
